import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { HomeDonationBusinessDto } from '@generated/unauth';
import { UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { ProjectCard } from '@/app/donation/_components/ProjectCard';
import { isDonationBusinessEnded } from '@/app/donation/_utils/isDonationBusinessEnded';
import { HOMETOWN_SECTION_PAGE_SIZE } from '../../constants';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
interface ProjectsContentProps {
  institutionId: number;
  initialData?: HomeDonationBusinessDto[];
}
export const ProjectsContent = t0 => {
  const $ = _c(9);
  const {
    institutionId,
    initialData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("grid grid-cols-3 gap-x-18 gap-y-16", "mobile-tablet:grid-cols-1");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InfiniteListMoreButton className={cn("mt-40", "mobile-tablet:mt-16")} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] !== institutionId) {
    t3 = [...UnauthQueryKey["get:/wello/v2/allows/home/donation-business"](), institutionId, HOMETOWN_SECTION_PAGE_SIZE];
    t4 = t5 => {
      const {
        pageParam
      } = t5;
      return UnauthApi["get:/wello/v2/allows/home/donation-business"]({
        query: {
          institutionId,
          page: pageParam,
          size: HOMETOWN_SECTION_PAGE_SIZE
        }
      }).then(_temp);
    };
    $[2] = institutionId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== initialData || $[6] !== t3 || $[7] !== t4) {
    t5 = <div><div className={t1}><InfiniteListWithMoreButton initialData={initialData} moreButtonComponent={t2} queryKey={t3} queryFn={t4} pageSize={HOMETOWN_SECTION_PAGE_SIZE} renderItem={_temp2} getItemKey={_temp3} /></div></div>;
    $[5] = initialData;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp(data) {
  return data.data?.context?.contents ?? [];
}
function _temp2(item) {
  return <ProjectCard daysLeft={item.dday} donationAmount={item.donationAmount} thumbnailUrl={item.thumbnailUrl} title={item.donationBusinessName} achievementRate={item.achievementRate} businessId={item.donationBusinessId} slugId={item.donationBusinessSlugId} isEnded={isDonationBusinessEnded(item)} />;
}
function _temp3(item_0) {
  return item_0.donationBusinessId;
}